import React, { memo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { useTranslation } from "react-i18next";
import useDetectIsInvited from "../../hooks/useDetectIsInvited";
import JoinGameSteps from "../JoinGameSteps";
import useCookie from "../../hooks/useCookie";

function FormHeader({ title, subtitle, titleClass, step, containerClass }) {
  const { t } = useTranslation();
  const isInvited = useDetectIsInvited();
  const { getCookie } = useCookie();
  FormHeader.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    titleClass: PropTypes.string,
    containerClass: PropTypes.string,
    step: PropTypes.number,
  };
  const titleCls = ["form-header__title neon-text"];
  const containerCls = ["form-header"];
  if (titleClass) titleCls.push(titleClass);
  if (containerClass) containerCls.push(containerClass);

  const [gameType, setGameType] = useState(null);

  useEffect(() => {
    const gameType = getCookie("gameType");
    setGameType(gameType);
  }, []);

  return (
    <div className={containerCls.join(" ")}>
      {step && !isInvited ? <JoinGameSteps currentStep={step} /> : null}

      <h1 className={titleCls.join(" ")} data-text={title}>
        {title}
      </h1>
      {subtitle ? (
        <div className="form-header__subtitle">{subtitle}</div>
      ) : null}
      {isInvited ? (
        <span className="form-header__subtitle form-header__subtitle--invited">
          {gameType === "DEMO"
            ? t("haveBeenInvitedDemo")
            : t("haveBeenInvited")}
        </span>
      ) : null}
    </div>
  );
}

export default memo(FormHeader);
